import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    response: null
}

export const responseSlice = createSlice({
    name: 'response',
    initialState,
    reducers: {
        setResponse: (state, action) => {
            state.response = action.payload;
        },
        resetResponse: () => initialState,
    }
});

export const { setResponse, resetResponse } = responseSlice.actions;

export default responseSlice.reducer;